import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import compose from '../../../hoc/compose';
import displayNames from '../../displayNames';

var DropDownStickyFooter = /*#__PURE__*/function (_React$Component) {
  _inherits(DropDownStickyFooter, _React$Component);

  var _super = _createSuper(DropDownStickyFooter);

  function DropDownStickyFooter() {
    _classCallCheck(this, DropDownStickyFooter);

    return _super.apply(this, arguments);
  }

  _createClass(DropDownStickyFooter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (_.isFunction(this.props.registerStickyFooter)) {
        this.props.registerStickyFooter(this);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (_.isFunction(this.props.registerStickyFooter)) {
        this.props.registerStickyFooter(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React.createElement('footer', {
        onClick: function onClick() {
          if (_this.props.closeOnClick && _.isFunction(_this.props.toggleOptions)) {
            _this.props.toggleOptions();
          }
        },
        className: this.props.getClassName('control-dropdown-sticky-footer'),
        'data-aid': this.props.automationId,
        'data-hook': this.props.dataHook
      }, this.props.children);
    }
  }]);

  return DropDownStickyFooter;
}(React.Component);

DropDownStickyFooter.displayName = displayNames.DROP_DOWN_STICKY_FOOTER;
DropDownStickyFooter.propTypes = {
  registerStickyFooter: PropTypes.func,
  closeOnClick: PropTypes.bool
};
DropDownStickyFooter.defaultProps = {};
export default compose(DropDownStickyFooter);